import { createLiteral } from 'modules/handlebars/domain/literal';
import { IConditionValue } from './IConditionValue';

export class LiteralValue<TValue> implements IConditionValue<TValue> {
  value: TValue;

  constructor(value: TValue) {
    this.value = value;
  }

  toExpression() {
    return createLiteral(this.value);
  }
}
